export const boxShadow = {
  sm: '2px 2px 3px rgba(0, 0, 0, 0.15)',
  md: '2px 2px 10px  rgba(0, 0, 0, 0.15)',
}
